import { SVGFC } from '@repo/toolkit/types'

const BankIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.2546 3.39856L9.12964 0.77356C9.04596 0.742798 8.95404 0.742798 8.87036 0.77356L1.74536 3.39856C1.59792 3.45271 1.49995 3.59306 1.5 3.75012V6.37512C1.49986 6.58212 1.66759 6.74998 1.87454 6.75012C1.8744 6.75012 1.87473 6.75012 1.87454 6.75012H3V12.788C2.12759 12.9671 1.50101 13.7345 1.5 14.6251V16.1251C1.49986 16.3321 1.66759 16.5 1.87454 16.5001C1.8744 16.5001 1.87473 16.5001 1.87454 16.5001H16.125C16.332 16.5003 16.4999 16.3325 16.5 16.1255C16.5 16.1254 16.5 16.1257 16.5 16.1255V14.6251C16.499 13.7345 15.8724 12.9671 15 12.788V6.75012H16.125C16.332 6.75026 16.4999 6.58253 16.5 6.37553C16.5 6.3754 16.5 6.37567 16.5 6.37553V3.75012C16.5 3.59306 16.4021 3.45271 16.2546 3.39856ZM15.75 14.6251V15.7501H2.25V14.6251C2.25069 14.0041 2.75395 13.5008 3.375 13.5001H14.625C15.246 13.5008 15.7493 14.0041 15.75 14.6251ZM3.75 12.7501V6.75012H6V12.7501H3.75ZM6.75 12.7501V6.75012H11.25V12.7501H6.75ZM12 12.7501V6.75012H14.25V12.7501H12ZM15.75 6.00012H2.25V4.0116L9 1.52502L15.75 4.0116V6.00012Z"
        fill={color}
      />
    </svg>
  )
}

export default BankIcon
